// AUTO-GENERATED — do not edit
export const BUILD_INFO = {
  "version": "0.1.0",
  "commit": "c7571c72",
  "buildTime": "2026-11-04T07:04:38.942Z"
} as const;
